export const CASH_BALANCE__TRANSFER = 'Transfer Balance';
export const BALANCE_TRANSFER__BREADCRUMB = 'Balance Transfer';

// Transfer Balance Modal
export const BALANCE_TRANSFER_MODAL__CANCEL_BUTTON = 'Cancel';
export const BALANCE_TRANSFER_MODAL__TRANSFER_BUTTON = 'Transfer';
export const BALANCE_TRANSFER_MODAL__CONFIRM_BUTTON = 'Confirm';
export const BALANCE_TRANSFER_MODAL__TRANSFER_TO = 'Transfer To';
export const BALANCE_TRANSFER_MODAL__TRANSFER_FROM = 'Transfer From';
export const BALANCE_TRANSFER_MODAL__HEADER = 'Transfer Balance';
export const BALANCE_TRANSFER_MODAL__AMOUNT_HELPER = (policyId: string) =>
	`This amount will result in a negative cash balance for policy ${policyId}`;
export const BALANCE_TRANSFER_MODAL__POLICYHOLDER_TITLE = 'Policyholder';
export const BALANCE_TRANSFER_MODAL__POLICY_TITLE = 'Policy';
export const BALANCE_TRANSFER_MODAL__TRANSFER_TYPE_TITLE = 'Transfer Type';
export const BALANCE_TRANSFER_MODAL__AMOUNT_TITLE = 'Amount';
export const BALANCE_TRANSFER_MODAL__COMMENTS_TITLE = 'Comments';

export const BALANCE_TRANSFER_CONFIRM__HEADER =
	'Are you sure you want to transfer from this policy?';
export const BALANCE_TRANSFER_CONFIRM__SUBHEADER = (nonZero: boolean) =>
	`This policy has a ${nonZero ? 'negative' : 'zero'} cash balance.`;
export const BALANCE_TRANSFER_CONFIRM__CANCEL_BUTTON = 'Cancel';
export const BALANCE_TRANSFER_CONFIRM__PROCEED_BUTTON = 'Continue To Transfer';

export const BALANCE_TRANSFER__SUCCESS_TOAST =
	'Balance transferred successfully';
export const BALANCE_TRANSFER__ERROR_TOAST = 'Error transferring balance ';
